<template>
    <div id="community">
        <div class="community-tab">
            <mt-navbar v-model="tabSelected" fixed>
                <mt-tab-item id="index1">老人列表</mt-tab-item>
                <mt-tab-item id="index2">新增老人</mt-tab-item>
            </mt-navbar>
            <mt-tab-container v-model="tabSelected">
                <mt-tab-container-item id="index1">
                    <div class="community-search">
                        <div class="search-content">
                            <input class="search" placeholder="搜索姓名/证件号码/电话" v-model="search" />
                            <i class="mintui mintui-search"></i>
                        </div>
                        <div class="search-filter" @click="showHideSearch">
                            高级搜索
                        </div>
                    </div>
                    <div class="advance-search" v-if="showAdvanceSearch">
                        <mint-select selectLabel="政府补偿" selectPatch="searchAllowance" :selectValue="searchAllowance" :slots="searchAllowanceSlots" @changeValue="changeValue"></mint-select>
                        <mint-select selectLabel="老人分类" selectPatch="searchElderType" :selectValue="searchElderType" :slots="searchElderTypeSlots" @changeValue="changeValue"></mint-select>
                        <mint-select selectLabel="居住情况" selectPatch="searchLiveStatus" :selectValue="searchLiveStatus" :slots="searchLiveStatusSlots" @changeValue="changeValue"></mint-select>

                        <mt-field label="起始年龄" placeholder="请输入起始年龄" type="number" v-model="begin_age"></mt-field>
                        <mt-field label="结束年龄" placeholder="请输入结束年龄" type="number" v-model="end_age"></mt-field>
                        <div class="search-form-button" @click="advanceSearch">
                            <a>搜索</a>
                        </div>
                    </div>

                    <ul class="mui-table-view community-list" v-infinite-scroll="loadMore" infinite-scroll-disabled="moreLoading" infinite-scroll-distance="0" infinite-scroll-immediate-check="false">
                        <!--li数据遍历循环部分-->
                        <li class="mui-table-view-cell community-card" v-for="item in list">

                            <div class="card-left" @click="enterView(item.id)">

                                <div class="card-sign" v-if="item.is_staff_sign>0">{{ item.sign_staff_name }}</div>


                                <div class="card-name" v-if="item.status==1">{{ item.name }} <span class="card-station">{{ item.station }}</span><a :href="'tel:'+item.phone" @click.stop>{{ item.phone }}</a></div>
                                <div class="card-name" v-if="item.status!==1"><span class="disabled-elder">{{ item.name }}</span> <span class="card-station">{{ item.station }}</span><a :href="'tel:'+item.phone" @click.stop>{{ item.phone }}</a></div>

                                <div class="card-address">{{ item.live_city_name+item.live_country_name+item.live_town_name+item.live_village_name+item.live_address }}</div>
                            </div>
                            <div class="card-right" @click="enterEdit(item.id)">
                                <a>编辑</a>
                            </div>
                        </li>
                        <!--底部判断是加载图标还是提示“全部加载”-->
                        <li class="more_loading" v-show="queryLoading">
                            <mt-spinner class="spinner" type="fading-circle"  color="#ffcb01;" :size="25"></mt-spinner>
                        </li>
                        <li class="more_loading" v-show="!queryLoading">
                            <span class="loaded">已全部加载</span>
                        </li>
                    </ul>
                </mt-tab-container-item>
                <mt-tab-container-item id="index2">

                    <div class="new-form">

                        <a href="javascript:;" class="a-upload">
                            <input type="file" ref="fileBtn" @change="uploadImg" multiple accept="image/*" />+ 上传身份证正面自动录入
                        </a>

                        <div class="img-preview" v-show="showPreview">
                            <img :src="imgSrc" class="img" ref="img" />
                        </div>
                        <mint-select selectLabel="*所属服务点" selectPatch="station" :selectValue="station" :slots="stationSlots" @changeValue="changeValue"></mint-select>

                        <mt-field label="*姓名" placeholder="请输入姓名" v-model="name"></mt-field>

                        <mint-select selectLabel="*性别" selectPatch="sex" :selectValue="sex" :slots="sexSlots" @changeValue="changeValue"></mint-select>
                        <mint-select selectLabel="*民族" selectPatch="nation" :selectValue="nation" :slots="nationSlots" @changeValue="changeValue"></mint-select>

                        <mint-select selectLabel="*身份证件类型" selectPatch="id_type" :selectValue="id_type" :slots="idTypeSlots" @changeValue="changeValue"></mint-select>
                        <mt-field label="*身份证件号码" placeholder="请输入身份证件号码" v-model="id_number" required></mt-field>

                        <mt-field label="*出生日期" placeholder="请输入出生日期" type="date" v-model="birthday"></mt-field>

                        <region-bar regionLabel="*户籍地址" @getAddress="getAddress" regionPatch="default_address"
                                    :province="default_address[0]" :city="default_address[1]" :country="default_address[2]" :town="default_address[3]" :village="default_address[4]" :address="default_address[5]"></region-bar>

                        <region-bar regionLabel="*居住地址" @getAddress="getAddress" regionPatch="live_address"
                                    :province="live_address[0]" :city="live_address[1]" :country="live_address[2]" :town="live_address[3]" :village="live_address[4]" :address="live_address[5]"></region-bar>

                       <!-- <mt-field label="身份证有效期" placeholder="请输入身份证有效期" v-model="id_number_validity"></mt-field>
                        <mt-field label="发证机关" placeholder="请输入发证机关" v-model="id_number_gov"></mt-field>-->

                        <mint-select selectLabel="*婚姻状况" selectPatch="marriage" :selectValue="marriage" :slots="marriageSlots" @changeValue="changeValue"></mint-select>
                        <mint-select selectLabel="宗教信仰" selectPatch="religion" :selectValue="religion" :slots="religionSlots" @changeValue="changeValue"></mint-select>

                        <mt-field label="*联系电话" placeholder="请输入联系电话" type="number" v-model="phone"></mt-field>

                        <mt-field label="其他号码" placeholder="多个电话请用英文,隔开"  v-model="other_phone"></mt-field>

                        <mint-select selectLabel="*政府补偿" selectPatch="allowance" :selectValue="allowance" :slots="allowanceSlots" @changeValue="changeValue"></mint-select>
                        <mint-select selectLabel="*老人分类" selectPatch="elder_type" :selectValue="elder_type" :slots="elderTypeSlots" @changeValue="changeValue"></mint-select>

                        <mt-checklist title="*居住情况" v-model="live_status" :options="liveStatusOptions"></mt-checklist>

                        <div class="new-form-button">
                            <mt-button size="large" type="primary" @click="addElder">提交</mt-button>
                        </div>
                    </div>
                </mt-tab-container-item>
            </mt-tab-container>
        </div>
        <footer-bar :messageCount="messageCount"></footer-bar>
    </div>
</template>

<script>
    import Region from '../components/region.vue'
    import mintSelect from '../components/mintSelect.vue'
    import Footer from '../components/footer.vue'

    export default{
        components: {
            'region-bar': Region,
            'mint-select':mintSelect,
            'footer-bar': Footer
        },

        data(){
            return {
                tabSelected:'index1',
                list:[],
                openid:JSON.parse(window.localStorage.getItem('UserInfo')).openid,

                //advancedSearch
                showAdvanceSearch:false,
                searchAllowance:'',
                searchElderType:'',
                searchLiveStatus:'',

                begin_age:'',
                end_age:'',

                searchElderTypeSlots:[
                    {
                        values: [],
                        className: 'slot1',
                        textAlign: 'center'
                    }
                ],

                searchLiveStatusSlots:[
                    {
                        values: [],
                        className: 'slot1',
                        textAlign: 'center'
                    }
                ],

                searchAllowanceSlots:[
                    {
                        values: [],
                        className: 'slot1',
                        textAlign: 'center'
                    }
                ],

                //advancedSearch

                //初始化无限加载相关参数
                queryLoading: true,
                pageNum:1,
                search:'',

                //身份证识别
                imgInfo: null,
                imgSrc: null,
                showPreview:false,
                imgSrcObj:{'test':'test'},

                name:'',
                birthday:'',
                id_number:'',

                choose:{
                    'nation':false,
                    'sex':false
                },

                station:'',
                stationSlots:[
                    {
                        values: [],
                        className: 'slot1',
                        textAlign: 'center'
                    }
                ],

                nation:'汉族',
                nationSlots: [
                    {
                        values: [],
                        className: 'slot1',
                        textAlign: 'center'
                    }
                ],

                id_type:'居民身份证',
                idTypeSlots: [
                    {
                        values: [],
                        className: 'slot1',
                        textAlign: 'center'
                    }
                ],

                sex:'男',
                sexSlots: [
                    {
                        values: ['男','女'],
                        className: 'slot1',
                        textAlign: 'center'
                    }
                ],

                default_address:[350, 350200000000, 350211000000, 350211001000, 350211001001,''],
                live_address:[350, 350200000000, 350211000000, 350211001000, 350211001001,''],

                marriage:'已婚',
                marriageSlots: [
                    {
                        values: [],
                        className: 'slot1',
                        textAlign: 'center'
                    }
                ],
                religion:'',
                religionSlots:[
                  {
                      values: [],
                      className: 'slot1',
                      textAlign: 'center'
                  }
                ],

                allowance:'无偿',
                allowanceSlots: [
                    {
                        values: [],
                        className: 'slot1',
                        textAlign: 'center'
                    }
                ],

                elder_type:'健康、活力老人',
                elderTypeSlots: [
                    {
                        values: [],
                        className: 'slot1',
                        textAlign: 'center'
                    }
                ],

                live_status:['与子女同住'],
                liveStatusOptions:[],


                id_number_gov:'',
                id_number_validity:'',
                phone:'',
                other_phone:'',

                messageCount:0

            }
        },

        created(){
            this.$indicator.open('加载中');

            this.$axios.post("/elder/list", {openid:this.openid,page:1,search:this.search,allowance:this.searchAllowance,elder_type:this.searchElderType,live_status:this.searchLiveStatus,begin_age:this.begin_age,end_age:this.end_age})
                .then(data => {

                    this.$indicator.close();

                    if (data.data.code === 'OK') {
                        this.list = data.data.data.data;
                        if(this.list.length<10){
                            this.queryLoading = false;
                        }
                    } else {
                        this.$toast(data.data.message);
                    }
                });

            this.$axios.post("/elder/option", {openid:this.openid})
                .then(data => {

                    if (data.data.code === 'OK') {
                        this.nationSlots[0].values = data.data.data.nation;
                        this.marriageSlots[0].values = data.data.data.marriage;
                        this.religionSlots[0].values = data.data.data.religion;
                        this.stationSlots[0].values = data.data.data.station;
                        this.idTypeSlots[0].values = data.data.data.id_type;
                        this.allowanceSlots[0].values = data.data.data.allowance;
                        this.elderTypeSlots[0].values = data.data.data.elder_type;


                        var live_status_array = Array();
                        for(let i=0;i<data.data.data.live_status.length;i++){
                            live_status_array[i] = { label:data.data.data.live_status[i],value:data.data.data.live_status[i]};
                        }
                        this.liveStatusOptions = live_status_array;

                        this.searchAllowanceSlots[0].values = data.data.data.allowance;
                        this.searchAllowanceSlots[0].values.unshift('');

                        this.searchElderTypeSlots[0].values = data.data.data.elder_type;
                        this.searchElderTypeSlots[0].values.unshift('');

                        this.searchLiveStatusSlots[0].values = data.data.data.live_status;
                        this.searchLiveStatusSlots[0].values.unshift('');

                    } else {
                        this.$toast(data.data.message);
                    }
                });

            this.$axios.get("/message/count?openid="+this.openid).then(data => {
                if(data.data.code === 'OK'){
                    this.messageCount = data.data.data;
                }

            });
        },


        watch:{
            search:{
                handler(){

                    this.pageNum = 1;
                    this.$axios.post("/elder/list", {openid:this.openid,page:1,search:this.search,search:this.search,allowance:this.searchAllowance,elder_type:this.searchElderType,live_status:this.searchLiveStatus,begin_age:this.begin_age,end_age:this.end_age})
                        .then(data => {
                            if (data.data.code === 'OK') {
                                this.list = data.data.data.data;
                                if(this.list.length<10){
                                    this.queryLoading = false;
                                }
                            } else {
                                this.$toast(data.data.message);
                            }
                        });
                    if(this.search===''){
                        this.queryLoading = true;
                    }
                }
            }
        },

        methods: {


            showHideSearch(){
                this.showAdvanceSearch = !this.showAdvanceSearch;
                this.resetSearchForm();
            },

            resetSearchForm(){
                this.searchAllowance = '';
                this.searchElderType = '';
                this.searchLiveStatus = '';
                this.begin_age = '';
                this.end_age = '';
            },

            advanceSearch(){
                this.queryLoading = true;
                this.$indicator.open('搜索中');
                this.$axios.post("/elder/list", {openid:this.openid,page:1,search:this.search,allowance:this.searchAllowance,elder_type:this.searchElderType,live_status:this.searchLiveStatus,begin_age:this.begin_age,end_age:this.end_age})
                    .then(data => {

                        this.$indicator.close();

                        if (data.data.code === 'OK') {
                            this.list = data.data.data.data;
                            if(this.list.length<10){
                                this.queryLoading = false;
                            }
                        } else {
                            this.$toast(data.data.message);
                        }
                    });
            },


            //无限加载函数
            loadMore() {

                if(!this.queryLoading){
                    return;
                }

                if(this.tabSelected==='index2'){
                    return;
                }

                this.pageNum++;
                this.$axios.post("/elder/list", {openid:this.openid,page:this.pageNum,search:this.search,allowance:this.searchAllowance,elder_type:this.searchElderType,live_status:this.searchLiveStatus,begin_age:this.begin_age,end_age:this.end_age}).then(data => {
                    if(data.data.code === 'OK'){

                        this.list = this.list.concat(data.data.data.data);
                        if(data.data.data.data.length===0){
                            this.queryLoading = false;
                        }
                    }

                });
            },

            async uploadImg() {
                let that = this;
                const inputFile = await this.$refs.fileBtn.files[0];
                let res;
                this.inputFile = inputFile;
                if (this.inputFile) {
                    let inputFile = this.inputFile;
                    if (inputFile.type !== 'image/jpeg' && inputFile.type !== 'image/png' && inputFile.type !== 'image/gif') {
                        alert('不是有效的图片文件！');
                        return;
                    }
                    this.showPreview = true;
                /*    this.imgInfo = Object.assign({}, this.imgInfo, {
                        name: inputFile.name,
                        size: inputFile.size,
                        lastModifiedDate: inputFile.lastModifiedDate.toLocaleString()
                    });*/
                 //   console.log(this.imgInfo);
                    const reader = new FileReader();
                    res = reader.readAsDataURL(this.inputFile);

                    reader.onloadend = function() {
                        // var strBase64 = reader.result.substring(84);

                        that.getBase64(reader.result).then(url => {
                           that.imgSrc = url;
                            that.$indicator.open('识别信息中...');
                            that.$axios.post("/elder/idCheck", {openid:that.openid,baseImg:url})
                                .then(data => {
                                    that.$indicator.close();

                                    if (data.data.code === 'OK') {
                                        console.log(data.data.data);
                                        that.name = data.data.data['姓名'].words;
                                        that.address = data.data.data['住址'].words;
                                        that.birthday = data.data.data['出生'].words;
                                        that.nation = data.data.data['民族'].words+'族';
                                        that.sex = data.data.data['性别'].words;
                                        that.id_number = data.data.data['公民身份号码'].words;
                                    } else {
                                        that.$toast(data.data.message);
                                    }
                                });
                        });

                    };
                    reader.onload = function(e) {
                   //     that.imgSrc = that.imgSrcObj.url;   // 注意:这里的this.result中,这个this不是vue实例,而是reader对象,所以之前用that接收vue示例  that.imgSrc
                    };
                } else {
                    return;
                }
            },

            // 图片压缩并保存到files
            getBase64(url) {
                let self = this;
                let Img = new Image(),
                    dataURL = "";
                Img.src = url;
                let p = new Promise(function(resolve, reject) {
                    Img.onload = function() {
                        //要先确保图片完整获取到，这是个异步事件
                        let canvas = document.createElement("canvas"), //创建canvas元素
                            width = Img.width, //确保canvas的尺寸和图片一样
                            height = Img.height;
                        // 默认将长宽设置为图片的原始长宽，这样在长宽不超过最大长度时就不需要再处理
                        let ratio = width / height,
                            maxLength = 1000,
                            newHeight = height,
                            newWidth = width;
                        // 在长宽超过最大长度时，按图片长宽比例等比缩小
                        if (width > maxLength || height > maxLength) {
                            if (width > height) {
                                newWidth = maxLength;
                                newHeight = maxLength / ratio;
                            } else {
                                newWidth = maxLength * ratio;
                                newHeight = maxLength;
                            }
                        }
                        canvas.width = newWidth;
                        canvas.height = newHeight;
                        canvas.getContext("2d").drawImage(Img, 0, 0, newWidth, newHeight); //将图片绘制到canvas中
                        dataURL = canvas.toDataURL("image/jpeg", 0.5); //转换图片为dataURL
                        resolve(dataURL);
                    };
                });
                return p;
            },

            changeValue(value){
                let props = value[0];
                this[props] = value[1];
            },

            getAddress(value){
                let props = value[0];
                this[props] = value[1];
            },

            addElder(){

                if(this.name===''||this.id_number===''||this.birthday===''||this.default_address[5]===''||this.live_address[5]===''||this.phone===''||this.allowance===''){
                    this.$toast('所有带*信息为必填项，请完善信息后添加');
                    return false;
                }

                if(!this.live_status.length>0){
                    this.$toast('请选择老人居住情况');
                    return false;
                }

                if(!this.elder_type.length>0){
                    this.$toast('请选择老人分类');
                    return false;
                }

                this.$indicator.open('加载中');

                this.$axios.post("/elder/create", {openid:this.openid,name:this.name,nation:this.nation,sex:this.sex,id_type:this.id_type,id_number:this.id_number,marriage:this.marriage,religion:this.religion,birthday:this.birthday,default_address:this.default_address,live_address:this.live_address,phone:this.phone,station:this.station,other_phone:this.other_phone,id_number_validity:this.id_number_validity,id_number_gov:this.id_number_gov,allowance:this.allowance,live_status:this.live_status,elder_type:this.elder_type})
                    .then(data => {

                        this.$indicator.close();

                        if (data.data.code === 'OK') {
                            this.$toast('创建成功!可在列表中点击编辑进一步补充！');
                            setTimeout(function(){
                                this.tabSelected = 'index1';
                                location.reload();
                            },2000);
                        } else {
                            this.$toast(data.data.message);
                        }
                    });
            },

            enterEdit(id){
                this.$router.push('/elder/'+id);
            },

            enterView(id){
                this.$router.push('/elder/detail/'+id);
            }

        }
    }

</script>

<style scoped>
    .community-tab .mint-navbar{
        padding: 0 15px;
        padding-top:13px;
    }
    .community-tab .mint-navbar .mint-tab-item{
        flex:none;
        width:25%;
    }
    .community-tab .mint-navbar .mint-tab-item-label{
        font-size:16px;
        font-weight:normal;
        color:#dedede;
    }
    .community-tab .mint-navbar .is-selected .mint-tab-item-label{
        color: #333;
    }
    .community-tab .mint-navbar .mint-tab-item.is-selected {
        border-bottom: 3px solid #ffcb01;
        margin-bottom: 0;
    }


    .community-search{
        background: #dedede;
        padding: 7px 20px;
        height: 30px;
        top:100px;
        display:flex;
        justify-content: space-between;
        margin-top: 62px;
    }
    .search-content{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        background: #fff;
        width: 78%;
        border-radius: 15px;
        height: 30px;
        line-height: 30px;
    }

    .search-content .search{
        font-size: small;
        width: 100%;
        border-radius: 20px;
        border: none;
        padding:0 20px;
    }

    .search-content .search:focus{
        outline: none;
    }

    .search-content i{
        padding-right:10px;
    }

    .search-filter{
        display:inline-block;
        font-size: 14px;
        line-height: 30px;
        color:#5a5a5a;
    }

    .advance-search{
        background:#fff;
        font-size: 14px!important;
    }

    .search-form-button{
        text-align: center;
        padding: 8px 0;
        background: #ffcb01;
        color: #fff;
    }

    .community-list{
        padding:0 20px 50px 20px;
    }

    .community-list li{
        list-style:none;
    }

    .community-card{
        display:flex;
        justify-content: space-between;
       /* border:1px solid #dedede;*/
        background:#fff;
        /*  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2), 0 2px 3px 0 rgba(0, 0, 0, 0.15);*/
        margin-bottom:10px;
        border-radius: 10px;
        position: relative;
    }

    .card-left{
        width:80%;
        font-size:14px;
        padding:15px 8px;
    }

    .card-right{
        width:20%;
        justify-content:center;
        display:flex;
        align-items: center;
        background:#ffcb01;
        color:#fff;
    }
    .card-name{
        padding:0 0 5px 0;
    }

    .card-name .card-station{
        font-weight:normal;
        font-size:12px;
    }

    .card-name .disabled-elder{
        background-color: #d2d6de;
        color: #444;
        font-size:12px;
        padding:3px 6px;
        border-radius:3px;
    }

    .card-name a{
        margin-left:10px;
        font-size:12px;
        text-decoration:none;
        color:#ffcb01;
    }


    .card-sign{
        font-size:10px;
        background:#ef4f4f;
        color:#fff;
        padding:3px 6px;
        border-top-left-radius:10px;
        border-bottom-right-radius:10px;
        margin-left: -8px;
        margin-top: -15px;
        width:50px;
        text-align:center;
        margin-bottom: 10px;
    }

    .card-address{
        font-size:12px;
        color:#848a8f;
    }

    .new-form{
        border-top:1px solid #dedede;
        padding-top:63px;
        padding-bottom:60px;
    }



    .a-upload {
        width:90%;
        margin:10px auto;
        text-align:center;
        height: 50px;
        line-height: 50px;
        position: relative;
        cursor: pointer;
        color: #888;
        background: #fafafa;
        border: 1px solid #ddd;
        border-radius: 4px;
        overflow: hidden;
        display: block;
        text-decoration: none;
    }

    .a-upload  input {
        position: absolute;
        font-size: 100px;
        right: 0;
        top: 0;
        opacity: 0;
        filter: alpha(opacity=0);
        cursor: pointer
    }

    .a-upload:hover {
        color: #444;
        background: #eee;
        border-color: #ccc;
        text-decoration: none
    }

    .img-preview{
        width: 90%;
        margin: 10px auto;
    }

    .img-preview img{
        width: 100%;
        height: 200px;
    }



</style>



// WEBPACK FOOTER //
// src/pages/community.vue